import { Component, OnInit, ViewChild } from '@angular/core';
import { HeaderColumn } from '../model/header-column.model';
import { HelperService } from '../services/helper.service';
import { ApiCommunicationService } from '../services/api-communication.service';
import { GridData } from '../model/grid-data.model';
import themes from 'devextreme/ui/themes';
import { HeaderType } from '../model/header-type.enum';
import { ReferencesService } from '../services/references.service';
import { _ } from '@biesbjerg/ngx-translate-extract/dist/utils/utils';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '../services/notification.service';
import { first } from 'rxjs/operators';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'app-reference',
  templateUrl: './reference.component.html',
  styleUrls: ['./reference.component.scss']
})
export class ReferenceComponent implements OnInit {

  @ViewChild('referenceDataGrid', { static: false })
  referenceDataGrid: DxDataGridComponent;

  constructor(private apiCommunicationService: ApiCommunicationService,
              private referencesService: ReferencesService,
              private translateService: TranslateService,
              private notificationService: NotificationService) {
  }

  headerType: HeaderType;
  division: string;
  parentRowKey: string;
  title;
  isVisible = false;
  data: any[] = [];
  headerColumns: HeaderColumn[] = [];
  allowedPageSizes = [5, 10, 'all'];
  pagerDisplayMode = 'full';
  selectionMode: string;
  allMode = 'allPages';
  checkBoxesMode: string = themes.current().startsWith('material') ? 'always' : 'onClick';
  loadPanelConfiguration = {
    enabled: false,
    showPane: false
  };
  selectedRows: any[] = [];

  ngOnInit(): void {
    this.getReferenceModeNotification();
  }

  private getReferenceModeNotification(): void {
    this.referencesService.getReferenceModeNotification().subscribe(referenceHelper => {
      if (referenceHelper.ParentRowKey === undefined) {
        this.notificationService.showErrorMessage('Parent RowKey is undefined. Cannot open reference modal.');
        return;
      }
      if (referenceHelper.HeaderType === undefined) {
        this.notificationService.showErrorMessage('Header type is undefined. Cannot open reference modal.');
        return;
      }
      if (referenceHelper.Division === undefined || referenceHelper.Division === '') {
        this.notificationService.showErrorMessage('Division is empty or undefined. Cannot open reference modal.');
        return;
      }
      this.parentRowKey = referenceHelper.ParentRowKey;
      this.headerType = referenceHelper.HeaderType;
      this.division = referenceHelper.Division;
      this.setupReferenceGrid();
      this.title = this.headerType === HeaderType.REPORTS ?
        this.translateService.instant(_('Reference Incident to Report')) :
        this.translateService.instant(_('Reference Reports to Incident'));
      this.selectionMode = this.headerType === HeaderType.INCIDENTS ? 'multiple' : 'single';
      this.isVisible = true;
    });
  }

  getGridWidth(): string {
    return 'calc(100vw - 430px)';
  }

  private setupReferenceGrid(): void {
    const lookupHeader = this.headerType === HeaderType.INCIDENTS ? HeaderType.REPORTS : HeaderType.INCIDENTS;
    this.apiCommunicationService.getGridColumns(lookupHeader).subscribe(columns => {
      columns.HeaderColumns.forEach(item => item.FieldName = item.FieldName.toUpperCase());
      this.headerColumns = columns.HeaderColumns.filter(column => column.IsVisible).sort(HelperService.sortGridHeaders);
      this.apiCommunicationService.getGridData(lookupHeader).subscribe(gridData => {
        this.setReferenceGridData(gridData);
      });
    });
  }

  private setReferenceGridData(gridData: GridData): void {
    const data: any[] = [];
    // HeaderType.REPORTS - can have incidents with references
    // HeaderType.Incidents - can't have reports already referenced
    gridData.Records.forEach(content => {
      if (this.headerType === HeaderType.REPORTS || !content.HasReferences) {
        const dataItem = {
          Type: content.Type,
          K3VRowKey: content.K3VRowKey
        };
        content.Fields.filter(field => field.IsVisible).forEach(field => {
          dataItem[field.FieldName.toUpperCase()] = field.Value;
        });
        const fieldName: any = 'MDP112'; // database field name for division
        if (dataItem[fieldName] === this.division) {
          data.push(dataItem);
        }
      }
    });
    this.data = data;
  }

  popupHiding(): void {
    this.isVisible = false;
    this.referenceDataGrid.instance.getScrollable().scrollTo(0);
  }


  createReference(e: MouseEvent): void {
    e.preventDefault();
    if (this.headerType === HeaderType.REPORTS) {
      this.apiCommunicationService.createReference(this.parentRowKey, this.selectedRows[0]).pipe(first()).subscribe(success => {
        if (!success) {
          this.notificationService.showErrorMessage('Could not create reference.');
        } else {
          this.notificationService.showSuccessMessage(`Reference successfully created!`);
          this.referencesService.refreshReportFormNotify();
          this.popupHiding();
        }
      });
    } else {
      this.apiCommunicationService.createReferences(this.parentRowKey, this.selectedRows).pipe(first()).subscribe(result => {
        if (result === -1) {
          this.notificationService.showErrorMessage('Could not create reference/s.');
        } else {
          this.notificationService.showSuccessMessage(`${result} reference/s successfully created!`);
          this.referencesService.refreshIncidentFormNotify();
          this.popupHiding();
        }
      });
    }

  }

  cancelReference(): void {
    this.selectedRows = [];
    this.popupHiding();
  }
}
